import Vue from 'vue'
import {TROLLBOX_MESSAGE_SEND} from "@/store/actions.type";
import RestService from "@/common/rest.service";
import {LOGOUT, TROLLBOX_MESSAGE, USER} from "@/store/mutations.type";

const state = {
    trollboxMessages: []
}

const getters = {
    trollboxMessages() {
        return state.trollboxMessages
    }
}

const actions = {
    [TROLLBOX_MESSAGE_SEND](context, text) {
        RestService.post('/trollbox/messages', {text})
    }
}

const mutations = {
    [USER]() {
        RestService.get('/trollbox/messages')
            .then(messages => {
                for(let n=messages.length-1; n>=0; n--) {
                    this.commit(TROLLBOX_MESSAGE, messages[n])
                }
            })
    },

    [TROLLBOX_MESSAGE](context, message) {
        state.trollboxMessages.push(message)
    },

    [LOGOUT]() {
        Vue.set(state, 'trollboxMessages', [])
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}